import {
  geosMainnet,
  nftsMainnet,
  farmingMainnet,
  auctionsMainnet,
} from "./mainnet";
import {
  geosMumbai,
  nftsMumbai,
  farmingMumbai,
  auctionsMumbai,
} from "./mumbai";

const { REACT_APP_ENV } = process.env;

const getContracts = () => {
  if (REACT_APP_ENV === "staging") {
    return {
      geosContract: geosMumbai,
      nftsContract: nftsMumbai,
      auctionsContract: auctionsMumbai,
      farmingContract: farmingMumbai,
    };
  } else {
    return {
      geosContract: geosMainnet,
      nftsContract: nftsMainnet,
      auctionsContract: auctionsMainnet,
      farmingContract: farmingMainnet,
    };
  }
};

export default getContracts;
